// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-l_gN","advertDetailHeaderPrice__value":"c-l_gO","advertDetailHeaderPrice__label":"c-l_gP"};